import * as React from 'react';
import { Button, Col, FormGroup, Radio } from 'react-bootstrap';
import { Category, IImageThumbnail } from '../Entities';
import { Translate } from '../../../../../shared/LanguageService';
import ConfirmationModal from '../../../../../components/common/ConfirmationModal';
import * as Feature from '../../../../../shared/Features';
import { handleError } from '../../../../../shared/ErrorCatching';
import { UserRole } from '../../../../../shared/types';
import normalIcon from '../../../../../assets/images/normal_scale_24px.svg';

export interface IProps {
    image: IImageThumbnail;
    imageType: number;
    orderId: number;
    showModalForImage: (
        id: number,
        imageType: number,
        idList: number[],
        canDelete: boolean
    ) => void;
    idList: number[];
    displayStitchRadio: boolean;

    leftStitchSelected(image: IImageThumbnail);

    rightStitchSelected(image: IImageThumbnail);

    onDelete?: (photoId: number) => Promise<any>;
    canDelete?: (photoId: number) => boolean;
    seeNormalIcon: boolean;
    seeNeedsEditingIcon: boolean;
    isFlex?: boolean;
    selectingMultiple: boolean;
    imageIsSelected: boolean;
    selectedExtraImages: number;
    imageSelected: (photoId: number, selected: boolean) => void;
    ctrlIsDown: boolean;

    updateImageCategory(orderId: number, imageId: number, category: number): void;

    selectingMultipleToolBox: boolean;
    user: any;

    handleSwap(droppedImage: number, targetImage: number): void;
}

interface IState {
    isDeleteLoading: boolean;
    showDeleteConfirmModal: boolean;
    categoryChanged: boolean;
    categoryChangedText: String;
}

class ImageThumbnail extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            isDeleteLoading: false,
            showDeleteConfirmModal: false,
            categoryChanged: false,
            categoryChangedText: ''
        };

        this.delete = this.delete.bind(this);
        this.showDeleteConfirmationModal = this.showDeleteConfirmationModal.bind(this);
        this.closeDeleteConfirmationModal = this.closeDeleteConfirmationModal.bind(this);
        this.imageClicked = this.imageClicked.bind(this);
        this.getChangeCategoryButtonText = this.getChangeCategoryButtonText.bind(this);
        this.getNewImageCategory = this.getNewImageCategory.bind(this);
        this.changeImageCategory = this.changeImageCategory.bind(this);
        this.getCurrentCategory = this.getCurrentCategory.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            if (this.props.image.overrideProperties) {
                if (
                    prevProps.image.overrideProperties &&
                    this.props.image.overrideProperties.categoryId !==
                    prevProps.image.overrideProperties.categoryId
                ) {
                    this.setState({
                        categoryChanged: true,
                        categoryChangedText: this.getChangedCategoryStickerText(
                            this.props.image.overrideProperties.categoryId
                        )
                    });
                } else if (
                    !prevProps.image.overrideProperties &&
                    this.props.image.overrideProperties.categoryId !== this.props.image.categoryId
                ) {
                    this.setState({
                        categoryChanged: true,
                        categoryChangedText: this.getChangedCategoryStickerText(
                            this.props.image.overrideProperties.categoryId
                        )
                    });
                }
            } else if (this.props.image.categoryId !== prevProps.image.categoryId) {
                this.setState({
                    categoryChanged: true,
                    categoryChangedText: this.getChangedCategoryStickerText(
                        this.props.image.categoryId
                    )
                });
            }

            setTimeout(() => {
                this.setState({ categoryChanged: false });
            }, 2500);
        }
    }

    searchCategoryName(category: number) {
        var key = Object.keys(Category).find((k) => Category[k] === category);
        return key.toLowerCase();
    }

    getChangedCategoryStickerText(category: number) {
        return Translate(
            `imagethumbnail/category-changed-text/${this.searchCategoryName(category)}`
        );
    }

    showDeleteConfirmationModal() {
        this.setState({ showDeleteConfirmModal: true } as IState);
    }

    closeDeleteConfirmationModal() {
        this.setState({ showDeleteConfirmModal: false } as IState);
    }

    delete() {
        this.setState({ isDeleteLoading: true } as IState);
        this.props.onDelete(this.props.image.id).catch((error: any) => {
            handleError(error);
            this.setState({ isDeleteLoading: false } as IState);
        });
    }

    imageClicked() {
        if (!this.props.selectingMultiple && !this.props.ctrlIsDown) {
            this.props.showModalForImage(
                this.props.image.id,
                this.props.imageType,
                this.props.idList,
                this.props.image.canDelete
            );
        } else {
            this.props.imageSelected(this.props.image.id, !this.props.imageIsSelected);
        }
    }

    getChangeCategoryButtonText() {
        switch (this.getCurrentCategory()) {
            case 1:
                return Translate('imagethumbnail/remove');
            case 2:
                if (this.props.selectedExtraImages < 0) {
                    return Translate('imagethumbnail/add');
                } else {
                    return Translate('imagethumbnail/buy');
                }
            case 3:
                return Translate('imagethumbnail/add');
            default:
                return Translate('imagethumbnail/remove');
        }
    }

    getNewImageCategory() {
        switch (this.getCurrentCategory()) {
            case Category.NORMAL:
                return Category.EXTRA;
            case Category.EXTRA:
                return Category.NORMAL;
            default:
                return Category.EJLEV;
        }
    }

    changeImageCategory() {
        this.props.updateImageCategory(
            this.props.orderId,
            this.props.image.id,
            this.getNewImageCategory()
        );
    }

    getCurrentCategory() {
        return this.props.image.overrideProperties
            ? this.props.image.overrideProperties.categoryId
            : this.props.image.categoryId;
    }

    render() {
        const { apiUrl } = window.appConfig;
        const userRole = this.props.user.details.role;

        return (
            <div>
                {this.props.displayStitchRadio && (
                    <FormGroup className="stitch-image-picker" inline>
                        <Radio
                            name="leftImage"
                            inline
                            onClick={() => this.props.leftStitchSelected(this.props.image)}
                        >
                            <span className="image-picker">
                                <i className="material-icons">image</i>
                                <i className="material-icons">chevron_left</i>
                            </span>
                        </Radio>
                        <Radio
                            name="rightImage"
                            inline
                            onClick={() => this.props.rightStitchSelected(this.props.image)}
                        >
                            <span className="image-picker">
                                <i className="material-icons">chevron_right</i>
                                <i className="material-icons">image</i>
                            </span>
                        </Radio>
                    </FormGroup>
                )}
                {this.props.imageIsSelected && (
                    <div
                        className="selected-action-icon"
                        data-testid="ImageThumbnail__selectedIcon"
                    >
                        {<i className="material-icons image-action-selected">check</i>}
                    </div>
                )}
                <div className="action-icons">
                    {this.props.image.hasUploadedNormal && this.props.seeNormalIcon && (
                        <div className="image-action-normal">
                            <img
                                src={normalIcon}
                                title={Translate(
                                    'image-processing/page/list/thumbnail/icons/has-uploaded-normal'
                                )}
                            />
                        </div>
                    )}
                    {this.props.image.needsEditing &&
                        this.props.seeNeedsEditingIcon &&
                        userRole !== UserRole.Photographer && (
                            <i
                                className="material-icons image-action-warning"
                                title={Translate(
                                    'image-processing/page/list/thumbnail/icons/needs-editing'
                                )}
                            >
                                feedback
                            </i>
                        )}
                    {this.props.image.hasOldNeedsEditing &&
                        !this.props.image.needsEditing &&
                        this.props.seeNeedsEditingIcon &&
                        userRole !== UserRole.Photographer && (
                            <i
                                className="material-icons image-action-warning old"
                                title={Translate(
                                    'image-processing/page/list/thumbnail/icons/has-old-needs-editing'
                                )}
                            >
                                feedback
                            </i>
                        )}
                    {this.props.image.hasComment && (
                        <i
                            className="material-icons image-action-comments"
                            title={Translate(
                                'image-processing/page/list/thumbnail/icons/has-comments'
                            )}
                        >
                            comment
                        </i>
                    )}
                    {this.props.image.hasOldComment && !this.props.image.hasComment && (
                        <i
                            className="material-icons image-action-comments old"
                            title={Translate(
                                'image-processing/page/list/thumbnail/icons/has-old-comments'
                            )}
                        >
                            comment
                        </i>
                    )}
                </div>
                <div>
                    {this.props.image.reference && (
                        <div
                            role="button"
                            className="img-button"
                            aria-label={this.props.image.filename}
                            title={this.props.image.filename}
                            onClick={this.imageClicked}
                        >
                            <img
                                className="img-responsive"
                                draggable={false}
                                src={`${apiUrl}/file/${this.props.image.reference}`}
                            />
                            <span className="img-label">
                                <span className="label-truncate">
                                    {this.props.image.filename ? this.props.image.filename.slice(0, -7) : ''}
                                </span>
                                <span>{this.props.image.filename ? this.props.image.filename.slice(-7) : ''}</span>
                            </span>
                        </div>
                    )}
                    {!this.props.image.reference && (
                        <div
                            className="img-button"
                            style={{ cursor: 'default' }}
                        >
                            <div className="img-responsive-spinner">
                                <span className="spin-container">
                                    <i className="load-spin-dark" />
                                </span>
                            </div>
                            <span className="img-label">
                                <span className="label-truncate">
                                    {this.props.image.filename && this.props.image.filename.substr(
                                        0,
                                        this.props.image.filename && this.props.image.filename.length - 7
                                    )}
                                </span>
                                <span>{this.props.image.filename && this.props.image.filename.substr(-7)}</span>
                            </span>
                        </div>
                    )}
                    {this.props.canDelete &&
                        this.props.canDelete(this.props.image.id) &&
                        this.props.image.reference &&
                        !this.state.isDeleteLoading &&
                        !this.props.selectingMultiple && (
                            <i
                                className="thumbnail-delete material-icons"
                                onClick={this.showDeleteConfirmationModal}
                                title={Translate(
                                    'image-processing/page/list/thumbnail/title/delete'
                                )}
                            >
                                delete
                            </i>
                        )}
                    {this.state.isDeleteLoading && (
                        <i className="thumbnail-delete-loading load-spin-dark" />
                    )}

                    {this.state.categoryChanged && (
                        <div className="thumbnail-category-changed-responsive-layer parent">
                            <p className="sticker">{this.state.categoryChangedText}</p>
                        </div>
                    )}

                    {Feature.hasFeature(Feature.ApproveImagesByCustomer, this.props.user) &&
                        !this.props.selectingMultipleToolBox &&
                        !this.state.categoryChanged &&
                        (!this.props.image.isCustomerApproved ||
                            (this.props.image.isCustomerApproved &&
                                this.getCurrentCategory() === 2)) && (
                            <Button
                                className="thumbnail-category-change label"
                                onClick={() => this.changeImageCategory()}
                            >
                                {this.getChangeCategoryButtonText()}
                            </Button>
                        )}

                    {this.state.showDeleteConfirmModal && (
                        <ConfirmationModal
                            closeModal={this.closeDeleteConfirmationModal}
                            title={Translate('delete/modal/title/delete')}
                            text={Translate(
                                'image-processing/page/list/thumbnail/modal/delete-text'
                            )}
                            doButtonLabel={Translate('delete/modal/footer/button-label/delete')}
                            cancelButtonLabel={Translate(
                                'delete/modal/footer/button-label/cancel'
                            )}
                            doButtonStyle="danger"
                            do={this.delete}
                        />
                    )}
                </div>
                {this.getCurrentCategory() === 1 && ( // Delivery
                    <div className="caption category">
                        <div className="label label-success-dark pull-right">
                            {Translate('order-page/edited-image/delivery')}
                        </div>
                    </div>
                )}
                {this.getCurrentCategory() === 2 && ( // Extra
                    <div className="caption category">
                        <div className="label label-warning pull-right">
                            {this.props.isFlex
                                ? Translate('image-processing/page/list/thumbnail/caption/flex')
                                : Translate(
                                    'image-processing/page/list/thumbnail/caption/extra'
                                )}
                        </div>
                    </div>
                )}
                {this.getCurrentCategory() === 3 && ( // No-delivery
                    <div className="caption category">
                        <div className="label label-danger pull-right">
                            {Translate(
                                'image-processing/page/list/thumbnail/caption/no-delivery'
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default ImageThumbnail;
